import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconSymbolResponsiveSizeType, IconSymbolSizeType } from '../../../../../theme/type/icon-symbol-type';
import { cn, textSizeClass } from '../../../../../utils/tailwind';
import { getSymbolSizeClasses, symbolImageSizeClass, symbolWrapperSizeClass } from '../symbol-icon-size';

const symbolTextSizeClass: Record<IconSymbolSizeType, string> = {
    xsmall: textSizeClass.xsmall,
    vsmall: textSizeClass.vsmall,
    small: textSizeClass.small,
    medium: textSizeClass.medium,
    large: textSizeClass.large,
    vlarge: textSizeClass.vlarge,
    xlarge: textSizeClass.xlarge,
};

interface SymbolIconEtfProps {
    size?: IconSymbolSizeType | IconSymbolResponsiveSizeType;
    shadow?: boolean;
}

export const SymbolIconEtf: React.FC<SymbolIconEtfProps> = ({ size = 'medium', shadow }) => {
    const { t } = useTranslation();

    const wrapperSizeClass = getSymbolSizeClasses(size, symbolWrapperSizeClass);
    const innerSizeClass = getSymbolSizeClasses(size, symbolImageSizeClass);
    const textSize = getSymbolSizeClasses(size, symbolTextSizeClass);

    return (
        <div
            className={cn(
                'inline-flex items-center justify-center overflow-hidden rounded-small border border-solid border-border bg-neutral-white text-small font-black not-italic leading-small text-text-muted',
                wrapperSizeClass,
                shadow && 'shadow-soft',
            )}
        >
            <div className={cn('inline-flex items-center justify-center font-black', innerSizeClass, textSize)}>
                {t('layout.symbols.etf')}
            </div>
        </div>
    );
};
